export { default as GrowlMessage } from 'messages/components/GrowlMessage';
export { default as InlineMessage } from 'messages/components/InlineMessage';



// WEBPACK FOOTER //
// src/modules/messages/components/index.js